// extracted by mini-css-extract-plugin
export default {"comments":"lsf-comments","waiting":"lsf-waiting"};